import {
  List,
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  FunctionField,
  TextInput,
  usePermissions,
} from "react-admin";

import { Chip, Box } from "@mui/material";

const assessmentFilters = [
  <TextInput
    label="Search by Title"
    source="q"
    alwaysOn
  />,
];

const AssessmentList = (props) => {
  const { permissions = [] } = usePermissions();

  

  return (
    <List
      title="Assessments"
      filters={assessmentFilters}
      {...props}
      sx={{
        "& .RaDatagrid-row": {
          height: 80,
          borderRadius: "12px",
        
        },
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: "background.paper",
      }}
    

    >
      <Datagrid
        rowClick="show"
        sx={{
          "& .RaDatagrid-row": {
            borderRadius: "12px",
            mb: 1,
          },
        }}
      >
        {/* ID */}
        <TextField source="id" />

        {/* TITLE */}
        <TextField source="title" />

        {/* DESCRIPTION (short) */}
        <FunctionField
          label="Description"
          render={(record) =>
            record.description
              ? record.description.slice(0, 40) + "..."
              : "-"
          }
        />

        {/* DURATION */}
        <FunctionField
          label="Duration"
          render={(record) => (
            <Chip
              label={`${record.duration || 0} min`}
              size="small"
            />
          )}
        />

        {/* PASSING SCORE */}
        <FunctionField
          label="Passing"
          render={(record) => (
            <Chip
              label={record.passing_score || 0}
              size="small"
            />
          )}
        />

        {/* TOTAL SCORE */}
        <FunctionField
          label="Total"
          render={(record) => (
            <Chip
              label={record.total_score || 0}
              size="small"
            />
          )}
        />

        
      </Datagrid>
    </List>
  );
};

export default AssessmentList;